import React from "react";
import "./styles.scss";
import WhatsHot from "./WhatsHot";
import QueryResults from "./QueryResults";
import qs from "qs";

export default class Browse extends React.Component {
  static getDerivedStateFromProps = (props, state) => ({
    query: qs.parse(props.location.search, {
      ignoreQueryPrefix: true
    }).q
  });

  render() {
    return (
      <div id="browse" className="browse m-4">
        {this.state.query ? (
          <QueryResults query={this.state.query} />
        ) : (
          <WhatsHot />
        )}
      </div>
    );
  }
}
